// AUTO-GENERATED by scripts/stamp_build_version.js — do not edit by hand.
// Rewritten on every yarn build via the prebuild script.
export const BUILD_VERSION = "2026-09-28T13:02:34.515Z";
